import React, { useEffect, useState } from "react";
import axios from "../../../utils/axios";
import { message, Spin } from "antd";

import EducationReports from "../education/educationReport";
import QSRREports from "../QsrFastFood/qsrreport";

const Reports = () => {

  const organizationId = localStorage.getItem("organizationId");
  const projectname = localStorage.getItem("selectedProject");
  const user = JSON.parse(localStorage.getItem("user"));

  const [sector, setSector] = useState(null);
  const [loading, setLoading] = useState(false);
  const [config, setConfig] = useState(null);

  /* -------- GET SECTOR -------- */

  const getProjectDetails = async () => {

    try {

      setLoading(true);

      const res = await axios.post("/get-project-details", {
        projectName: projectname,
        organizationId
      });

      if (res?.data?.project?.mainCategory) {
        setSector(res.data.project.mainCategory);
      }

    } catch (err) {

      if (err.response?.data?.msg) {
        message.error(err.response.data.msg);
      } else {
        message.error("Something went wrong");
      }

    } finally {
      setLoading(false);
    }

  };

  /* -------- GET PAGE CONFIG -------- */

  const fetchConfig = async () => {

    try {

      const res = await axios.post("/fetch-dashboard-settings", {
        organizationId,
        username: user?.username,
        projectname
      });

      if (res.data?.success) {
        setConfig(res.data.data.pages?.report);
      }

    } catch (err) {
      console.error(err);
    }

  };

  useEffect(() => {
    getProjectDetails();
    fetchConfig();
  }, [projectname]);

  /* -------- SECTOR ROUTER -------- */

  const PageRouter = () => {

    switch (sector) {

      case "Education":
        return <EducationReports config={config} />;

      case "QSR / Fast Food":
        return <QSRREports config={config} />;
  
      default:
        return <div>No reports available</div>;

    }

  };


  return (

    <div className="max-w-7xl mx-auto">

      {/* HEADER */}
      <div className="mb-8">

        <h1 className="text-4xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
          Reports
        </h1>

      </div>
      {loading ? <Spin /> :
      <PageRouter />}

    </div>

  );

};

export default Reports;